var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-icon',{style:(_vm.svgStyle),attrs:{"icon-class":"explicit"}})}
var staticRenderFns = []

export { render, staticRenderFns }